import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';

export const Page = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 100%;
  padding: 0;
  width: 100%;
`;

export const BottomSpacer = styled('div')`
  flex-shrink: 0;
  height: calc(45px + env(safe-area-inset-bottom, 0px));

  @media (max-width: ${breakpoints.tablet}) {
    height: calc(25px + env(safe-area-inset-bottom, 0px));
  }
`;
